<template>

    <div class="question__self-disable">
        <label class="choice__label" :class="{ '-selected': isSelected }">
            <input type="checkbox"
                class="checkbox-input"
                value="1"
                :checked="isSelected"
                :disabled="$parent.readOnly"
                @change.stop="changeValue"
                :tabindex="$parent.questionIndex"
                :aria-labelledby="'sd_' + $parent.uuid"
            >
            <small v-once v-html="label" :id="'sd_' + $parent.uuid"></small>
        </label>
    </div>

</template>

<script>
import { SELF_DISABLED_VALUE } from '../../constants';

export default {
    name: 'self-disablable',

    props: {
        label: [String, Boolean],
        answer: [String, Object, Array],
    },

    computed: {
        isSelected()
        {
            return (this.answer == SELF_DISABLED_VALUE);
        },

    },

    methods: {
        changeValue($event)
        {
            const $target = $($event.target);
            const state = $target.is(':checked') ? SELF_DISABLED_VALUE : null;
            this.$parent.setSelfDisabled(state);
        },

    },


}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/self-disablable.vue